<template>
  <AdminConfirmModal
    v-model="getActivateCompanyModal"
    :message="$t('Tariffs.sure_want_activate_company')"
    :confirm-text="$t('Default.activate')"
    confirm-color="sub white--text"
    cancel-color="main_color white--text"
    @confirm="ActivateCompany"
  />
</template>
<script>
import { shortComputed } from "@/utility/helpers";
import { useStore } from "vuex-composition-helpers";
import { globalVariables } from "@/utility/variables";
import { GlobalMutationTypes } from "@/store/modules/global/types";
import companyInstance from "@/services/api/company";
import AdminConfirmModal from "@/components/partials/Admin/AdminConfirmModal.vue";

export default {
  components: { AdminConfirmModal },
  props: ["currentCompany", "onSuccess"],
  setup(props, { root }) {
    const store = useStore();
    const { userInfo } = globalVariables();

    const getActivateCompanyModal = shortComputed(
      {
        storeType: "global",
        key: "getActivateCompanyModal",
      },
      GlobalMutationTypes.setActivateCompanyModal
    );

    const ActivateCompany = () => {
      companyInstance.activateCompany(props.currentCompany.id).then((res) => {
        store.commit(GlobalMutationTypes.setActivateCompanyModal, false);
        props.onSuccess();
      });
    };

    return {
      store,
      userInfo,
      getActivateCompanyModal,
      ActivateCompany,
    };
  },
};
</script>
